import React from "react";

const IconCheck = (props) => {
  return (
    <svg
      width={props?.width ?? "22"}
      height={props?.height ?? "22"}
      viewBox="0 0 10.6 7.71"
      {...props}
    >
      <path
        dataname="Path 9279"
        d="M-678.391,3978.9l2.686,2.688,6.5-6.5"
        transform="translate(679.098 -3974.382)"
        fill="none"
        stroke={props?.stroke ?? "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={props.strokeWidth ?? 1}
      />
    </svg>
  );
};

export default IconCheck;
